import getFirebaseAuth from 'actions/firebase/auth'
import { signInAnonymously } from 'firebase/auth'

const guestLogin = async () => signInAnonymously(getFirebaseAuth())

export default guestLogin
